function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0a8b0af8\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"./scss/mbstalas/_wp_variables.scss\",\"./node_modules/bootstrap/scss/_mixins.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dcard.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dcard.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a8b0af8\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dcard.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a8b0af8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/_eng/globals/dcard.vue
// module id = 1531
// module chunks = 146